<template>
  <div>
    <BannerLogo />
    <h2 class="pa-4 text-h3 text-center primary--text" v-text="title" />
    <v-container>
      <v-row>
        <ProfileCard
          name="C. Saunders Roberson, Jr."
          image-handle="CSaundersRobersonJr"
          position="Managing Partner"
          class="my-12"
        >
          <Roberson />
        </ProfileCard>
        <ProfileCard
          name="J. Lee Lloyd"
          image-handle="JLeeLloyd"
          position="M&amp;A Attorney / Advisor"
          class="my-12"
        >
          <Lloyd />
        </ProfileCard>
        <ProfileCard
          name="Sonya Adams Rozier"
          image-handle="SonyaARozier"
          position="Managing Director"
          class="my-12"
        >
          <Rozier />
        </ProfileCard>
        <ProfileCard
          name="Sandra B Lindsey"
          image-handle="SandraLindsey"
          position="Director of Executive Operations"
          class="my-12"
        >
          <Lindsey />
        </ProfileCard>
      </v-row>
    </v-container>
    <ManagementAchievements />
  </div>
</template>

<script>
import BannerLogo from '@/components/core/BannerLogo'
import ProfileCard from '@/components/management_team/ManagementProfileCard'
import Roberson from '@/components/management_team/team_members/CSaundersRobersonJr'
import Lloyd from '@/components/management_team/team_members/JLeeLloyd'
import Rozier from '@/components/management_team/team_members/SonyaAdamsRozier'
import Lindsey from '@/components/management_team/team_members/SandraBLindsey'
import ManagementAchievements from '@/components/management_team/ManagementAchievements'

export default {
  name: 'ManagementTeam',
  metaInfo: {
    title: 'Management Team',
    meta: [
      {description: 'Guided by decades of diverse healthcare operating experience, we actively work with portfolio companies to build local and regional businesses into a national platform.'}
    ]
  },
  components: {
    BannerLogo,
    ProfileCard,
    Roberson,
    Lloyd,
    Rozier,
    Lindsey,
    ManagementAchievements,
  },
  data() {
    return {
      title: 'HealthView Capital Management Team',
    }
  },
  methods: {},
}
</script>
